import { createFileRoute } from '@tanstack/react-router'
import { supplierSearchSchema } from '../../../features/suppliers/search'
import { SuppliersListPage } from '../../../features/suppliers/suppliers-list-page'

export const Route = createFileRoute('/_app/suppliers/')({
  validateSearch: supplierSearchSchema,
  component: SuppliersListPage,
})
